import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IBetData } from "../../../core/src/server/data/IBetData";
import App from "../../../core/src/App";
import { BetConfigType } from "../../../core/src/utils/ConfigType";
import BetModel from "../../../core/src/model/BetModel";
import Configs from "../../vendorConfigs/Configs";
import IPaytableMapItem from "../../../core/src/managers/contracts/configurations/IPaytableMapItem";
import CurrencyUtils from "../../../core/src/utils/CurrencyUtils";
import * as currency_config from "../../../core/src/baseConfigs/currency-config.json";

import { InfoResponse, AuthResponse } from "../FTypes";
export default class BetDataParser implements IBaseDataParser<IBetData> {
    private specialCurrencies: string[] = ['bk', 'bt', 'fc', 'gc', 'sc', 'st','stakegc','stakesc'];

    check(data: InfoResponse<unknown> & AuthResponse): boolean {
        return !!data?.bets;
    }

    parse(data: InfoResponse<unknown> & AuthResponse): IBetData[] {
        // Parsing the paytable map
        let paytableMap: IPaytableMapItem[] = [];
        data.config.paytable.forEach((payLine) => {
            const symbolsCount = payLine.n;
            const multiplier = payLine.pay;
            const key = `pt_sym_${payLine.symbol}_${symbolsCount}`;
            const paytableMapItem: IPaytableMapItem = {
                key: key,
                multiplier: multiplier,
            };

            paytableMap.push(paytableMapItem);
        });

        Configs.settings.ptMap = paytableMap;

        BetModel.betDivisor = 25;
        BetModel.currencyRate = 1;
        BetModel.currencyMultiplier = 1;
        const currencyISO = data.currency || "EUR";
        const decimals = 2;

        const symbol = this.getCurrencySymbol(currencyISO)
        const multi = BetModel.currencyRate;
        const locale = data.jurisdiction;
        const currencyLocalization = CurrencyUtils.createCurrencyLocalization(
            currencyISO,
            symbol,
            decimals,
            multi,
            locale
        );

        BetModel.setCurrency(currencyLocalization);

        let bets: number[] = data.bets.main.available;
        let coinSize = data.bets.main.default;
        let result: IBetData = {
            betMultipliers: [1],
            // creditValues:  Utils.parseStringifiedListOfNumbers(data.Response.Bet.attributes.validChips),
            // betMultipliers: Utils.parseStringifiedListOfNumbers(
            //     data.Response.Bet.attributes.validChips
            // ),
            currentBetMultiplier: 1,
            creditValues: bets,
            coinSize,
            coinSizeIndex: bets.indexOf(coinSize),
            minLinesAllowed: 1,
            maxLinesAllowed: 1,
            currency: {
                decimals: currencyLocalization.currency.decimals,
                symbol: currencyLocalization.currency.symbol,
                ISO: currencyLocalization.currency.ISO,
            },
            allPossibleBets: this.parsePossibleBets(bets, 1),
            numLines: 1,
        };

        return [result];
    }

    parsePossibleBets(
        bets,
        linesCount
    ): { coinIndex: number; multiplier: number; value: number }[] {
        let result = [];
        // let values = [];
        let betConfig = App.assets.getConfig("betConfig") as BetConfigType;
        // let validValues = betConfig.validBets;
        // let multipliers = Utils.parseStringifiedListOfNumbers(data.validChips);
        bets.forEach((bet, betIndex) => {
            // multipliers.forEach((val, coinIndex) => {
            let currentValue = bet * linesCount;
            // if (values.indexOf(currentValue) == -1 &&
            //     (!validValues || validValues.indexOf(currentValue) != -1)
            // ) {
            // values.push(currentValue);
            result.push({
                total: currentValue,
                coinIndex: betIndex,
                multiplier: 1,
                value: currentValue,
            });
            // }
            // });
        });

        result = result.sort((a, b) => {
            if (a.total > b.total) {
                return 1;
            } else if (a.total < b.total) {
                return -1;
            }
            return 0;
        });

        return result;
    }

    private getCurrencySymbol = (currencyISO) => {
        // This find currency symbol
        const currencyFormat: string = window?.clientRgsService?.CurrenciesDisplayFormat[currencyISO.toUpperCase()];
        const configSymbol = currencyFormat.replace(/[.,#]/g, '').trim();

        if (configSymbol) {
            return configSymbol;
        }

        const formatParts = currencyFormat.split(' ');

        if (formatParts.length === 1) {
            // If format is just "#,###.##", return an empty string
            return '';
        }

        // Check if the symbol is at the beginning or end of the format
        return formatParts[0] === '#,###.##' ? formatParts[1] : formatParts[0];
    };
}
